import Config from "../config";
import axios from "axios/index";
import {notification} from "../helpers";

export function get(reportId,getParams) {
    return (dispatch) => {
        dispatch({
            type: 'REPORTS_GET_INPROCESS',
            payload: true
        });
        return axios.get(Config.api.getDomain() + 'report/'+reportId+getParams ,Config.api.getConfig())
            .then(response => {
                // Fix for problematic response for mountedOnCar report data
                const responseData = typeof response.data === 'string' && !response.data.endsWith(']') ? JSON.parse(`${response.data}]`) : response.data;
                dispatch({
                    type: 'REPORTS_GET_SUCCESS',
                    payload: responseData
                });
            })
            .catch(error => {
                notification("Did not get data!");
                dispatch({
                    type: 'REPORTS_GET_FAILURE',
                    payload: error
                });
            })
    };
}


// WEBPACK FOOTER //
// ./src/actions/reports.js